/**
 * Requests that make up a profile load. An error carries the one that failed.
 */
export const PROFILE_REQUESTS = Object.freeze({
  Profile: 'profile'
});
